import { request, download } from "./index";

// 定义获取字典的函数
export const fetchDictByRoot = (dictStr) => {
    return request({
        method: "POST",
        url: "/ubi/api/dict/byRootDict",
        data: {
            dictType: dictStr,
        },
    });
};

// 分公司树状结构
export const fetchCompanyTree = () => {
    return request({
        method: "get",
        url: "/ubi/api/tenant/companyTree",
        params: {},
    });
};

// 用户对应租户的城市信息
export const fetchCurrentTenantArea = () => {
    return request({
        method: "get",
        url: "/ubi/api/tenant/currentTenantArea",
        params: {},
    });
};
